<template>

  <div class="active-basic">
    <div class="common-form">基本信息</div>

    <el-form-item label="选择用户">
      <el-row>
        <el-button @click="addClick" icon="el-icon-plus">选择会员</el-button>
        <div v-if="form.user_id!=''" class="img">
          <img :src="form.user.avatarUrl" width="100" height="100" />
        </div>
        <div>
          <el-link :underline="false" disabled v-if="form.user">{{form.user.nickName}}</el-link>
        </div>
        <div>
          <el-link :underline="false" disabled>选择后不可更改</el-link>
        </div>
      </el-row>
    </el-form-item>

    <el-form-item label="项目标题" prop="title" :rules="[{ required: true, message: '请输入项目标题' }]">
      <el-input v-model="form.title" placeholder="请输入项目标题" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="项目内容">
      <!-- <div class="edit_container"> -->
         <el-input type="textarea" v-model="form.introduce" placeholder="请输入项目内容" class="max-w460"></el-input>
      <!-- </div> -->
    </el-form-item>

    <el-form-item label="详细地址" prop="address" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.address" placeholder="请输入详细地址" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="地址坐标">
      <el-row class="mb16">
        <el-col :span="24">
          <el-input v-model="form.coordinate" class="max-w460"></el-input>
        </el-col>
      </el-row>
      <el-row class="mb16">
        <el-col :span="24">
          <Getpoint :form="form" @getMapdata="getMapdataFunc" @chose="choseFunc"></Getpoint>
        </el-col>
      </el-row>
    </el-form-item>

    <el-form-item label="联系方式" prop="mobile">
      <el-input type="number"  v-model="form.mobile" placeholder="请输入联系方式" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="预算" prop="budget">
      <el-input type="number"  v-model="form.budget" placeholder="请输入项目预算" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="浏览次数" prop="view">
      <el-input type="number"  v-model="form.view" placeholder="请输入浏览次数" class="max-w460"></el-input>
    </el-form-item>
    
    <!--添加-->
    <GetUser :is_open="open_add" @close="closeDialogFunc"></GetUser>
  </div>
</template>

<script>
import Getpoint from '@/components/map/Getpoint.vue';
import Uediter from '@/components/UE.vue';
import Upload from '@/components/file/Upload';
import GetUser from '@/components/user/GetUser.vue';
export default {
  components: {
    Uediter,
    Upload,
    Getpoint,
    GetUser
  },
  data() {

    return {
      ueditor: {
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      open_add:false,

    };
  },
  props: ['form'],
  methods: {
    
    /*获取经纬度*/
    getMapdataFunc(e) {
      this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
      this.form.latitude = e.data[0].toFixed(6);
      this.form.longitude = e.data[1].toFixed(6);
    },
    /*选择的地址*/
    choseFunc(e){
      this.form.coordinate=e.location.lat+','+e.location.lng;
      this.form.latitude = e.location.lat
      this.form.longitude = e.location.lng;
      this.form.address=e.address;

    },

    /*打开弹出层*/
    addClick() {
      console.log
      this.open_add = true;
    },

    /*关闭获取用户弹窗*/
    closeDialogFunc(e) {
      if (e.type != 'error') {
        this.form.user = e.params[0];
        this.form.user_id = e.params[0].user_id;
      }
      this.open_add = false;
    },
  }
};
</script>

<style lang="scss">
.active-basic .ad-picture {
  width: 300px;
  height: 124px;
  border-radius: 16px;
  font-size: 40px;
  border: 1px dashed #cccccc;
  color: $blue;
  cursor: pointer;
  overflow: hidden;
}
.active-basic .ad-picture:hover {
  border: 1px dashed $blue;
}

.active-basic .ad-picture img {
  object-fit: fill;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/project/project/part/Basic.vue